export default __webpack_public_path__ + "58f3f1db459e42463b1888b26b327192.svg";